import { useCase } from "../useCase";
import { addDays, endOfDay } from "date-fns";
import CustomerIntakeForm from "./CustomerIntakeForm";
import AquamationSelectionForm from "./AquamationSelectionForm";
import PostAquamationSelection from "./PostAquamationSelection";

function CustomerFollowup() {
  const { caseData, isLoadingCase } = useCase();

  const dateWithinThreeDays =
    endOfDay(addDays(caseData?.createdTime, 3)) > new Date();
  const dateWithinSevenDays =
    endOfDay(addDays(caseData?.createdTime, 7)) > new Date();

  if (isLoadingCase)
    return <div className="loading-screen regular-2xl">Loading...</div>;

  if (!caseData) return <div className="container">Case not found</div>;

  if (!caseData.fields.aquamationType) return <CustomerIntakeForm />;

  if (caseData.fields.aquamationType === "Undecided" && dateWithinThreeDays)
    return <AquamationSelectionForm caseData={caseData} />;

  return (
    <PostAquamationSelection
      caseData={caseData}
      dateWithinThreeDays={dateWithinThreeDays}
      dateWithinSevenDays={dateWithinSevenDays}
    />
  );
}

export default CustomerFollowup;
